import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { chefText } from './chefStyles';
import FocusedHeading from './FocusedHeading';
import { caloTheme } from '../assets/themes/calo';

const { palette } = caloTheme;

type EndMessageProps = { title: string; line?: string; action?: ReactNode };

const EndMessage = ({ title, line, action }: EndMessageProps) => (
  <Box sx={{ gridColumn: '1 / -1', textAlign: 'center', py: 8, width: '100%' }}>
    <FocusedHeading>{title}</FocusedHeading>
    {line !== undefined && <Typography sx={{ mt: 1, ...chefText.body, color: palette.neutral800 }}>{line}</Typography>}
    {action !== undefined && <Box sx={{ mt: 3 }}>{action}</Box>}
  </Box>
);

export default EndMessage;
